// Export all error handlers for easy importing
export { handleAuthenticationError } from './authenticationHandler'
export { reportGraphQLError, reportNetworkError } from './errorReporter'
export { handleExtensionError } from './extensionErrorHandler'
export { handlePhoneValidationError } from './phoneValidationHandler'
export type { ErrorCallback, ExtensionErrorParams } from './types'
